<template>
    <div class="stepper">
        <span @click="step <= maxStep ? setActiveStep(step): null" v-for="step in steps" :class="'step step-' + step" :key="step">{{ step
            }}</span>
    </div>
</template>

<script>
export default {
    props: {
        activeStep: Number,
        steps: Number,
        maxStep: Number,
        setCurrentStep: Function
    },
    watch: {
        activeStep: function() {
            this.applyVisualState(this.activeStep);
        }
    },
    data: function () {
        return {
            
        }
    },
    mounted() {
        this.applyVisualState(this.activeStep);
    },
    methods: {
        setActiveStep(step) {
            this.setCurrentStep(step);
            this.$nextTick(() => this.applyVisualState(this.activeStep));
        },
        applyVisualState(step) {
            const steps = document.querySelectorAll(".step");
            if (!steps.length) return;
            steps.forEach((s, index) => {
                s.classList.remove("active");
                s.classList.remove("done");
                s.innerHTML = index + 1;
            });

            for (let i = 1; i < step; i++) {
                const el = document.querySelector(".step-" + i);
                if (el) {
                    el.classList.add("done");
                    if (!el.querySelector("i"))
                        el.innerHTML += "<i class='fa-regular fa-check'></i>";
                }
            }

            const activeEl = document.querySelector(".step-" + step);
            if (activeEl) activeEl.classList.add("active");
        },
    }
}
</script>
<style lang="scss">
.stepper {
    display: flex;
    flex-direction: row;
    // Fixed gap instead of a fixed width so the tournament wizard's seven
    // steps (SFB-1289) and the funding wizard's four share the same spacing.
    gap: 18px;

    .step {
        display: flex;
        justify-content: center;
        border-radius: 100px;
        color: #9A9A9A;
        font-family: "Avenir", "Produc Sans", sans-serif;
        font-size: 16px;
        border: 1px solid #9A9A9A;
        width: 25px;
        height: 25px;
        padding: 0;
        margin: 0;

        &.active {
            color: var(--v-mainGreen-base);
            border-color: var(--v-mainGreen-base);
        }

        &.done {
            background: var(--v-mainGreen-base);
            position: relative;
            
            i {
                color: var(--v-mainWhite-base);
                position: absolute;
                z-index: 3;
                border-radius: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 25px;
                height: 25px;
                font-size: 16px;
                background: var(--v-mainGreen-base);
                top: -1px;
            }
        }

        &:hover {
            cursor: pointer;
        }
    }
}
</style>